'use client';
import React, { useCallback, useRef, useState } from 'react';
import cx from 'classnames';
import { useIsActive, useIsFocused, useIsHovered, useIsPointerDevice } from '@THC/hooks';
import { blurInput, filterDataProps, focusInput } from '@THC/utils/helpers';
import { CodeInput, getSegmentCssWidth } from '@THC/vendors/rci/rci';
import { INPUT_AUTH_TIMEOUT_DELAY } from './InputAuth.helpers';
import styles from './InputAuth.module.scss';
const RCIConfigProps = {
    fontFamily: '',
    fontSize: '24px',
    paddingX: '10.5px',
    paddingY: '12px',
    spacing: '14px',
};
const renderSegment = ({ width }) => ({ index, state: segmentState }) => (<div key={index} className={styles.segment} data-state={segmentState} style={{ width }}>
				<div className={styles.cursor}/>
			</div>);
export const InputAuth = (props) => {
    const { autoComplete = 'one-time-code', autoFocus, defaultValue, id, length = 6, onFill } = props;
    const [inputState, setInputState] = useState('input');
    const inputRef = useRef(null);
    const isPointerDevice = useIsPointerDevice();
    const focused = useIsFocused(inputRef);
    const hovered = useIsHovered(inputRef);
    const active = useIsActive(inputRef);
    const labelId = `${id}-label`;
    const dataProps = filterDataProps(props);
    const onSuccess = useCallback((callback) => {
        setInputState('success');
        if (callback) {
            setTimeout(callback, INPUT_AUTH_TIMEOUT_DELAY);
        }
    }, []);
    const onError = useCallback((callback) => {
        setInputState('error');
        blurInput(inputRef);
        if (callback) {
            callback();
        }
        setTimeout(() => {
            setInputState('input');
            if (inputRef.current) {
                inputRef.current.value = '';
                if (!isPointerDevice) {
                    focusInput(inputRef);
                }
            }
        }, INPUT_AUTH_TIMEOUT_DELAY);
    }, [isPointerDevice]);
    return (<label htmlFor={id} {...dataProps}>
			<CodeInput {...RCIConfigProps} {...{ autoComplete, autoFocus, defaultValue, id, inputRef, length }} aria-describedby={props['aria-describedby'] || labelId} aria-label={props['aria-label'] || 'Enter OTP code you received in the text message'} className={cx(styles.inputAuth, styles[inputState], {
            [styles.focused]: focused,
            [styles.hovered]: hovered,
            [styles.active]: active,
        })} disabled={inputState === 'loading'} inputMode="numeric" onChange={(event) => {
            const { currentTarget: input } = event;
            input.value = input.value.replace(/\D+/g, '');
            if (input.value.length === length) {
                setInputState('loading');
                onFill?.({
                    event,
                    onError,
                    onSuccess,
                    value: input.value,
                });
            }
        }} pattern="[0-9]*" readOnly={inputState !== 'input'} renderSegment={renderSegment({ width: getSegmentCssWidth(RCIConfigProps.paddingX) })} spellCheck={false}/>
		</label>);
};
